import { render } from "./SportAchieve.vue?vue&type=template&id=515e6940"
const script = {}
script.render = render

export default script